import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.5 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM39 44.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5ZM39 46a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM38 9.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM38 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM8 38.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM8 40a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm14-9.75a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5ZM22 32a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.381 28.619 11.12 33.88a.875.875 0 0 1-1.238-1.237l5.263-5.263a.875.875 0 1 1 1.237 1.238ZM36.326 9.381a.875.875 0 0 1 0 1.238l-8.207 8.207a.875.875 0 1 1-1.238-1.238l8.207-8.207a.875.875 0 0 1 1.238 0Zm-25.707 3a.875.875 0 0 1 1.237 0l5.263 5.263a.875.875 0 1 1-1.238 1.237L10.62 13.62a.875.875 0 0 1 0-1.238Zm24.762 26.238a.875.875 0 0 1-1.237 0l-7.763-7.763a.875.875 0 0 1 1.238-1.237l7.762 7.762a.875.875 0 0 1 0 1.238Z",
      clipRule: "evenodd"
    }
  )
);
var SvgIntegrations1Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Integrations1Outlined_default = SvgIntegrations1Outlined;

export { Integrations1Outlined_default as default };
